import React from 'react';

import { DomainNameVerificationStatus } from '@dashboard/generated/wp/platform';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import DomainNameRow from './DomainNameRow';
import { useCurrentDomainNameVerificationQuery } from './hooks';
import StepTitle, { StepTitleStatus } from './StepTitle';

export default function DkimSection() {
  const { data } = useCurrentDomainNameVerificationQuery();
  const model = data?.DomainNameVerification;

  const renderBody = () => {
    if (!model) {
      return (
        <>
          <DomainNameRow recordType="CNAME" name="" value="" />
          <DomainNameRow recordType="CNAME" name="" value="" />
          <DomainNameRow recordType="CNAME" name="" value="" />
        </>
      );
    }

    return model.verificationDnsRecords.map((r, i) => (
      <DomainNameRow key={i} recordType={r.type} isPresent={r.isPresent} name={r.name} value={r.value} />
    ));
  };

  const renderStatusIcon = () => {
    if (!model) {
      return <StepTitleStatus status="LOADING" label="Loading" />;
    }
    switch (model.status) {
      case DomainNameVerificationStatus.Failed:
        return <StepTitleStatus status="FAILED" label="Failed" />;
      case DomainNameVerificationStatus.Pending:
        return <StepTitleStatus status="PENDING" label="Pending" />;
      case DomainNameVerificationStatus.Succeeded:
        return <StepTitleStatus status="SUCCEEDED" label="Verified" />;
    }
  };

  return (
    <Box>
      <StepTitle title="DKIM authentication records (required)" status={renderStatusIcon()} />
      <TableContainer>
        <Table size="small" sx={{ '& th, & td': { border: 0 } }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" variant="head" width={64}>
                Status
              </TableCell>
              <TableCell variant="head" width={96}>
                Type
              </TableCell>
              <TableCell variant="head">Hostname</TableCell>
              <TableCell variant="head">Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody()}</TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
